const EMAIL_REGEX =
  /^[A-Za-z0-9]+([._%+-]+?[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

export function isValidEmail(email: string): boolean {
  return email?.trim().length > 5 && EMAIL_REGEX.test(email);
}
